import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BACKEND_API_URL } from "../../config";

const initialState = {
  data: {
      fairhousing_sign_option: '',
      fairhousing_sign_image: null,
      fairhousing_sign_link: '/',
      // hdma_sign_option: 'No',
      // hdma_sign_image: null,
      // hdma_sign_link: '/',
      labor_law_sign_option: '',
      labor_law_sign_image: null,
      labor_law_sign_link: '/',
    }, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'ComplianceSignage/fetch', 
  async (data, { getState, dispatch }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/compliance_signage?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // // console.log(initialState);
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return initialState.data
      }
    
  })



// Create New 
export const SubmitComplianceSignage = createAsyncThunk(
    'ComplianceSignage/submit',
    async (_data, { getState, dispatch, rejectWithValue }) => {
      try {
          let { name, data } = _data
          const {token} = getState().navigator;

          // A sign upload / delete is a partial save: it carries a File (or the
          // 'delete' marker) for one sign, so the *other* sign is allowed to still
          // be missing at that point. The Next button submits without a File and
          // therefore still enforces both checks below.
          const isFileOnlySave = ['fairhousing_sign_image', 'labor_law_sign_image'].some(
            (field) => data[field] instanceof File || data[field] === 'delete'
          );

          // // console.log('data: ', data);
          if (!isFileOnlySave && data.fairhousing_sign_option === 'Yes' && (!data.fairhousing_sign_image || data.fairhousing_sign_image === "null")) {
              // alert("Please upload the Fairhousing Sign!");
              // dispatch(updateFairhousingSignOption(''))
              return rejectWithValue('Please upload the Fairhousing Sign!');
          }
          // else if (data.hdma_sign_option === 'Yes' && (!data.hdma_sign_image || data.hdma_sign_image === "null")) {
          //     // alert("Please upload the HDMA Sign!");
          //     dispatch(updateHDMASignOption(''))
          //     return rejectWithValue('Please upload the HDMA Sign!');
          // }
          else if (!isFileOnlySave && data.labor_law_sign_option === 'Yes' && (!data.labor_law_sign_image || data.labor_law_sign_image === "null")) {
              // alert("Please upload the Labor Law Sign!");
              // dispatch(updateLaborLawSignOption(''))
              return rejectWithValue('Please upload the Labor Law Sign!');
          }

        if (data.fairhousing_sign_option === '' ) {
            // alert("Please Select Fairhousing Sign Option!");
            return rejectWithValue('Please Select Fairhousing Sign Option!');
        }
        // else if (data.hdma_sign_option === '' ) {
        //     // alert("Please Select the HDMA Sign Option!");
        //     return rejectWithValue('Please Select the HDMA Sign Option!');
        // }
        else if (name !== 'fairhousing' &&  data.labor_law_sign_option === '' ) {
            // alert("Please Select the Labor Law Sign Option!");
            return rejectWithValue('Please Select the Labor Law Sign Option!');
        }
          // because of Image, send as FormData
          const formData = new FormData();
            Object.keys(data).forEach((key) => {
              formData.append(key, data[key]);
          });

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/compliance_signage?token=${token}`, {
              method: 'POST',
              body: formData
          });
          const response_data =  await response.json();
          // A failed save must reject — returning here would resolve the thunk and
          // move the user to the next step with nothing saved.
          if (!response.ok) {
            return rejectWithValue(response_data?.error || 'Could not save the compliance signage. Please try again.');
          }
          // Handle the response data
          // // console.log('Form submitted successfully', response_data);

          return response_data.data;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Returning the error would count as a success, so it is rejected instead
          return rejectWithValue('Could not save the compliance signage. Please check your connection and try again.');
        }
      }
)


// Slice

export const complianceSignageSlice = createSlice({
    name: 'ComplianceSignage',
    initialState,
    reducers: {
      updateFairhousingSignOption: (state, action) => {
        state.data.fairhousing_sign_option = action.payload;
      },
      // updateHDMASignOption: (state, action) => {
      //   state.data.hdma_sign_option = action.payload;
      // },
      updateLaborLawSignOption: (state, action) => {
        state.data.labor_law_sign_option = action.payload;
      },
    },
    extraReducers: (builder) => {
        builder
          // FETCH
          // CREATE or UPDATE
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = {...state.data, ...action.payload};
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // CREATE or UPDATE
          .addCase(SubmitComplianceSignage.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitComplianceSignage.fulfilled, (state, action) => {
            state.loading = false;
            state.data = {...state.data, ...action.payload};
          })
          .addCase(SubmitComplianceSignage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateFairhousingSignOption, updateLaborLawSignOption } = complianceSignageSlice.actions;

export default complianceSignageSlice.reducer;
  